export const siteConfig = {
  name: "PlayPro",
  description: null,
  theme: "blue",
  layout: "vertical",
  // semi-box, horizontal, vertical
  hideSideBar: false,
  sidebarType: "classic",
  // popover, classic, module
  sidebarColor: null,
  navbarType: "sticky",
  // sticky, floating, static
  footerType: "static",
  // sticky,  static, hidden
  sidebarBg: "none",
  radius: 0.5,
};
